import { deepCopy, deepFreeze } from '@/utils'
import { IDevice } from '@/types/model'
import easyapi from '@/easyapi'

export type language_t = 'auto' | 'en' | 'zh' | 'ja'
export const ALL_LANG_KEY = ['en', 'zh', 'ja']
export type thumb_size_t = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
export const THUMB_SIZE_ALL: thumb_size_t[] = ['xs', 'sm', 'md', 'lg', 'xl']
export const THUMB_SIZE_VW: thumb_size_t[] = ['sm', 'md', 'lg', 'xl']
export type devlst_vmode_t = 'plain' | 'grouped'
export type dev_property_t = keyof IDevice

export interface DeviceListPref {
  viewMode: devlst_vmode_t
  showingField: dev_property_t
  thumbSize: thumb_size_t
  sortBy: dev_property_t
}

export interface MatrixPref {
  thumbSize: thumb_size_t
}
export interface VWPref {
  thumbSize: thumb_size_t
}
export interface GlobalPref {
  lang: language_t
}

export interface State {
  global: GlobalPref,
  deviceList: DeviceListPref,
  matrix: MatrixPref
  vw: VWPref
}

const DEFAULT_STATE: State = {
  global: {
    lang: 'auto'
  },
  deviceList: {
    viewMode: 'plain',  // unused currently
    showingField: 'ip',
    thumbSize: 'md',
    sortBy: 'mac',
  },
  matrix: { thumbSize: 'md' },
  vw: { thumbSize: 'md' },
}
deepFreeze(DEFAULT_STATE)

const thisState = deepCopy(DEFAULT_STATE)

const mutations = {
  assignStateSafely (state: State, root: null|object|State): void {
    let r = root as State
    if (!r) { r = deepCopy(DEFAULT_STATE) }
    if (!r.global) { r.global = DEFAULT_STATE.global }
    if (!r.global.lang) { r.global.lang = DEFAULT_STATE.global.lang }
    if (!r.deviceList) { r.deviceList = DEFAULT_STATE.deviceList }
    if (!r.deviceList.viewMode) { r.deviceList.viewMode = 'plain' }
    Object.assign(state, r)
  },
  assignLang (state: State, lang: language_t) {
    state.global.lang = lang
    easyapi.saveCurrentUserPreference()
  },
  assignDeviceList (state: State, x: Partial<DeviceListPref>) {
    Object.assign(state.deviceList, x)
    easyapi.saveCurrentUserPreference()
  },
  assignMatrix (state: State, newVal: Partial<MatrixPref>) {
    Object.assign(state.matrix, newVal)
    easyapi.saveCurrentUserPreference()
  },
  assignVW (state: State, newVal: Partial<VWPref>) {
    Object.assign(state.vw, newVal)
    easyapi.saveCurrentUserPreference()
  },
}

const actions = {
}

export default {
  namespaced: true,
  state: thisState,
  mutations,
  actions
}
